import React from 'react'
import styled from 'styled-components'
import { heading4 } from '@gassan-ui'

const StyledAnchor = styled.span<{ isActive?: boolean }>`
  ${heading4};
  display: inline-block;
  margin-bottom: 1rem;
  position: relative;
  z-index: 0;

  span {
    position: relative;
    &::before {
      position: absolute;
      content: '';
      bottom: -5px;
      width: 140%;
      height: 100%;
      z-index: -1;
      left: -20%;
      background: ${p => p.theme.colors.pampasLight};
    }
  }

  &::after {
    transition: opacity 0.2s ease;
    position: absolute;
    bottom: 4px;
    content: '';
    width: 100%;
    height: 1px;
    background: currentColor;
    left: 0;
    z-index: -2;
    opacity: 0;
  }

  &:hover,
  &:focus {
    &::after {
      opacity: 1;
    }
  }

  ${p =>
    p.isActive &&
    `
      pointer-events: none;
      &::after {
        opacity: 1;
      }
    `}
`

const specials = ['g', 'j', 'p', 'q', 'y']

type Props = {
  isActive: boolean
  title: string
}

const CategoryLink = React.forwardRef<HTMLAnchorElement, Props>(({ isActive, title }, ref) => (
  <StyledAnchor
    isActive={isActive}
    ref={ref}
    dangerouslySetInnerHTML={{
      __html: title
        .split('')
        .map(letter =>
          specials.includes(letter.toLowerCase()) ? `<span>${letter}</span>` : letter
        )
        .join('')
    }}
  />
))

export default CategoryLink
